import { ServiceCode } from '../../../../../../common/enums/serviceCode';

type partialServiceCode = Partial<Record<ServiceCode, string>>;

export const serviceGroupsByServiceCodes: partialServiceCode = {
    [ServiceCode.GGZOint]: 'examination',
    [ServiceCode.GGZOembl]: 'examination',
    [ServiceCode.GGZBther]: 'counseling',
};
